import { render, staticRenderFns } from "./PublicationComponent.vue?vue&type=template&id=f4975af4&scoped=true&"
import script from "./PublicationComponent.vue?vue&type=script&lang=js&"
export * from "./PublicationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PublicationComponent.vue?vue&type=style&index=0&id=f4975af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4975af4",
  null
  
)

export default component.exports